__turbopack_context__.v({
  "container": "SecondaryRegionListSection-module__Gms2Mq__container",
  "regionsWrapper": "SecondaryRegionListSection-module__Gms2Mq__regionsWrapper",
  "secondaryRegion": "SecondaryRegionListSection-module__Gms2Mq__secondaryRegion",
  "title": "SecondaryRegionListSection-module__Gms2Mq__title",
});
